/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"PageHeading":"PageHeading_lIG+M","heading":"heading_9eEHW"};